import { KYCStatus } from "@funded-here-interface/common/src/constant/enum";

export const getKycColor = (kyc: string): string => {
  switch (kyc) {
    case KYCStatus.APPROVED:
      return "green";
    case KYCStatus.PENDING_APPROVAL:
      return "orange";
    case KYCStatus.REJECTED:
      return "red";
    case KYCStatus.PENDING_RESUBMISSION:
      return "yellow";
    default:
      return "green";
  }
};
